import { render, staticRenderFns } from "./IconButtonView.vue?vue&type=template&id=3473af51&"
import script from "./IconButtonView.vue?vue&type=script&lang=js&"
export * from "./IconButtonView.vue?vue&type=script&lang=js&"
import style0 from "./IconButtonView.vue?vue&type=style&index=0&id=3473af51&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports